import { z } from 'zod';

export const SupplierInvitationKind = Object.freeze({
  Platform: 'platform',
  DeclarantConnection: 'declarant_connection',
  DeclarantDataRequest: 'declarant_data_request',
});

const isoDate = z.string().regex(/^\d{4}-\d{2}-\d{2}$/);

const requestSchema = z
  .object({
    goods: z.array(z.string().min(1).max(64)).min(1).max(100),
    reportingPeriod: z.string().min(1).max(32),
    period: z
      .object({
        start: isoDate,
        endExclusive: isoDate,
      })
      .strict(),
  })
  .strict();

const unavailableSchema = z
  .object({ version: z.literal(1), status: z.literal('unavailable') })
  .strict();

export const invitationInspectSchema = z.discriminatedUnion('status', [
  unavailableSchema,
  z
    .object({
      version: z.literal(1),
      status: z.literal('available'),
      kind: z.nativeEnum(SupplierInvitationKind),
      declarantName: z.string().optional(),
      request: requestSchema.optional(),
      expiresAt: z.string().datetime(),
    })
    .strict(),
]);

export const invitationClaimSchema = z.discriminatedUnion('status', [
  unavailableSchema,
  z
    .object({
      version: z.literal(1),
      status: z.literal('claimed'),
      kind: z.nativeEnum(SupplierInvitationKind),
      clerkOrganisationId: z.string().min(1),
      operatorId: z.string().min(1),
      membershipRole: z.enum(['org:admin', 'org:member']),
      resumed: z.boolean(),
    })
    .strict(),
]);

export const invitationClaimErrorSchema = z
  .object({
    version: z.literal(1),
    status: z.enum([
      'retryable_error',
      'identity_mismatch',
      'manual_review_required',
      'workspace_suspended',
    ]),
    code: z.string().min(1),
    message: z.string().min(1),
  })
  .strict();
